import React from 'react'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
const Testimonials = () => {
    const testimonials = [
        {
            name: "Tony",
            role: "Software Engineer",
            text: "Locknpay's hosting solutions have been a game-changer for our e-commerce business. We experienced a 30% improvement in page load speeds, which boosted our sales.",
            initial: "T"
        },
        {
            name: "Michael",
            role: "Streamer",
            text: "I've been hosting my gaming servers with Locknpay for a while, and they're the best I've tried. The performance is unmatched, and their pricing is fair.",
            initial: "M"
        },
        {
            name: "Laura",
            role: "IT Manager",
            text: "Locknpay has completely revolutionized our team's workflow. Their servers are lightning-fast, and their support team is incredibly responsive.",
            initial: "L"
        }
    ];

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: true
    };
    return (
        <div>
            <section className="relative py-10 lg:py-24 sm:py-32 overflow-hidden">
                <div className="mx-auto max-w-7xl px-6 lg:px-8">
                    <div className="lg:grid lg:grid-cols-2 lg:gap-16 items-center">
                        <div className="mx-auto max-w-2xl md:mb-16">
                            <div className="inline-flex px-4 py-2 rounded-full bg-blue-50 border border-blue-400/30 mb-4">
                                <span className="text-sm font-medium text-blue-400">Trusted By Clients And Industry Experts Alike</span>
                            </div>
                            <h2 className="text-3xl font-bold tracking-tight sm:text-4xl">Testimonials</h2>
                            <p className="text-sm font-normal text-gray-400 pt-4">
                                We are hosting 1,700,000 domains while making website owners less stressed, more productive, and hopefully just a little happier.
                            </p>
                        </div>
                        {/* <div className="view_all_testimonial py-5 text-end inline-block">
                            <a href="#"
                                className="rounded-lg px-6 py-3.5 text-sm font-semibold text-blue-500 ring-1 ring-blue-800/30 hover:ring-blue-700/50 transition-all duration-200 text-center group">
                                View All <span className="inline-block transition-transform group-hover:translate-x-1 ml-2">→</span>
                            </a>
                        </div> */}
                    </div>
                    <div className="relative mt-10">
                        <Slider {...settings}>
                            {testimonials.map((testimonial, index) => (
                                <div key={index} className="px-4">
                                    <div className="relative backdrop-blur-xl bg-gray-50/50 rounded-xl p-8 h-full border border-blue-200/10 hover:border-blue-800/50 transition-colors duration-300">
                                        <svg className="h-8 w-8 text-blue-600 mb-6" fill="currentColor" viewBox="0 0 24 24">
                                            <path d="M4.583 17.321C3.553 16.227 3 15 3 13.011c0-3.5 2.457-6.637 6.03-8.188l.893 1.378c-3.335 1.804-3.987 4.145-4.247 5.621.537-.278 1.24-.375 1.929-.311 1.804.167 3.226 1.648 3.226 3.489a3.5 3.5 0 01-3.5 3.5c-1.073 0-2.099-.49-2.748-1.179zm10 0C13.553 16.227 13 15 13 13.011c0-3.5 2.457-6.637 6.03-8.188l.893 1.378c-3.335 1.804-3.987 4.145-4.247 5.621.537-.278 1.24-.375 1.929-.311 1.804.167 3.226 1.648 3.226 3.489a3.5 3.5 0 01-3.5 3.5c-1.073 0-2.099-.49-2.748-1.179z"></path>
                                        </svg>
                                        <div className="star_client pb-5">
                                            <ul className="flex text-blue-600 gap-1">
                                                <li><i className="fa-solid fa-star"></i></li>
                                                <li><i className="fa-solid fa-star"></i></li>
                                                <li><i className="fa-solid fa-star"></i></li>
                                                <li><i className="fa-solid fa-star"></i></li>
                                                <li><i className="fa-solid fa-star"></i></li>
                                            </ul>
                                        </div>
                                        <p className="text-gray-400 mb-6">“{testimonial.text}”</p>
                                        <div className="flex items-center">
                                            <div className="h-10 w-10 rounded-full bg-blue-900/30 flex items-center justify-center">
                                                <span className="text-blue-500 font-semibold text-lg">{testimonial.initial}</span>
                                            </div>
                                            <div className="ml-4">
                                                <div className="text-sm font-semibold">{testimonial.name}</div>
                                                <div className="text-xs text-gray-400">{testimonial.role}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </Slider>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default Testimonials
